import React, {useEffect, useState} from 'react';
import {Button} from "flowbite-react";
import {getUser} from "../../services/userService";
import {initializeUser, UserType} from "../../model/user/userInterface";
import {toast} from "react-toastify";

const Profile: React.FC = () => {
    const [userDetail, setUserDetail] = useState<UserType>(initializeUser);

    useEffect(() => {
        handleGetUser();
    }, []);
    const handleGetUser = async () => {
        const user = await getUser();
        setUserDetail(user);
    }
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        toast.success("Update feature coming soon");
    }
    return (
        <div className="mt-16 px-12 justify-center">
            <div className="px-16 flex flex-col md:items-center">
                <div className="flex justify-center items-center">
                    <h1 className="text-2xl font-bold">My Profile</h1>
                </div>
                <form className="flex flex-col justify-center" onSubmit={(e) => handleSubmit(e)}>
                        <div className="flex flex-col mt-5 mb-5 gap-5 w-full">
                            <div className="md:flex block w-full md:gap-4">
                                <div className="flex flex-col md:mb-0 mb-4">
                                    <label> First name: </label>
                                    <input className="border border-black rounded-lg"
                                           type="text"
                                           name="fname"
                                           defaultValue={userDetail?.firstName || ''}
                                           required
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label> Last name: </label>
                                    <input className="border border-black rounded-lg"
                                           type="text"
                                           name="lname"
                                           defaultValue={userDetail?.lastName || ''}
                                           required
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <label> Email: </label>
                                <input className="border border-black rounded-lg"
                                       type="email"
                                       name="email"
                                       defaultValue={userDetail?.email || ''}
                                       required
                                />
                            </div>
                            <div className="md:flex block w-full gap-4">
                                <div className="flex flex-col md:mb-0 mb-4 ">
                                    <label> Company: </label>
                                    <input className="border border-black rounded-lg"
                                           type="text"
                                           name="company"
                                           defaultValue={userDetail?.company || ''}
                                           required
                                    />
                                </div>
                                <div className="flex flex-col ">
                                    <label> Title: </label>
                                    <input className="border border-black rounded-lg"
                                           type="text"
                                           name="title"
                                           defaultValue={userDetail?.title || ''}
                                           required
                                    />
                                </div>
                            </div>
                            <div className="flex justify-end">
                                <Button color="dark" type="submit">
                                    Update
                                </Button>
                            </div>
                        </div>
                </form>
            </div>
        </div>
    );
};

export default React.memo(Profile);
